import axios from '../../utils/axios';

const materialPreviews = {
    get: (params = {}, pathParams: PathParams) => axios.get(`v1/materials/${pathParams.id}/previews`, { params })
};

export default materialPreviews;
